import {
  GET_FILE_GCG,
  SET_LOADING_FILE_GCG,
  SET_PAGINATION_FILE_GCG,
} from "../constant";

const initialState = {
  fileGCG: [],
  fileGCGPagination: 0,
  loadingFileGCG: false,
  totalFileGCG: 0,
};

const GCGReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_FILE_GCG: {
      return {
        ...state,
        loadingFileGCG: action?.payload,
      };
    }
    case SET_PAGINATION_FILE_GCG: {
      return {
        ...state,
        fileGCGPagination: action?.payload,
      };
    }
    case GET_FILE_GCG: {
      return {
        ...state,
        fileGCG: action?.payload?.data || [],
        totalFileGCG: action?.payload?.total,
        loadingFileGCG: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default GCGReducer;
